export default __webpack_public_path__ + "static/media/DSC_0533.e9dc4189.jpg";